import React from 'react';

export default function Footer() {
  return (
    <footer className="app-footer">
      © 2025 Bản đồ Ẩm thực Hà Nội - All rights reserved.
    </footer>
  );
}